package com.markettwits.waifupics.root.core



class DefaultWaifuPicsApp() {

    init {
        initKoinApp()
    }

}
